module.exports = __webpack_public_path__ + "static/media/img3-1.a760319b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/frijol/soilcheck/mo/img3-1.png
// module id = 1624
// module chunks = 3